import { useUserSelector, useAuthSelector } from './selectors';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAsync } from 'react-use';
import { signin, getToken } from '@/lib/oidc-client';
import { nativeStore } from './nativeStore';
import { authRequested, userSignout } from './events';

export const useAuth = () => {
  const { pathname, search } = useLocation();
  const user = useUserSelector();
  const isAuth = useAuthSelector();

  const signout = useCallback(() => {
    if (nativeStore.redirectToSignout) {
      return;
    }

    nativeStore.redirectToSignout = true;
    userSignout();
  }, []);

  const signinRedirect = useCallback(() => {
    const searchParams = new URLSearchParams(search);
    const redirectUri = searchParams.get('redirect_uri') ?? undefined;

    signin({ redirectUri });
  }, [search]);

  useEffect(() => {
    if (!isAuth) {
      authRequested();
    }
  }, [isAuth, pathname]);

  return { isAuth, user, signout, signinRedirect };
};

export const useToken = () => {
  const [token, setToken] = useState<string | undefined | null>('n/a');

  useAsync(async () => {
    const storedToken = await getToken();
    setToken(storedToken);
  }, [setToken]);
  return { token };
};
